<template>
  <wizard/>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Wizard from "@/components/Wizard.vue";

export default defineComponent({
  name: 'App',
  components: {
    Wizard
  }
});
</script>

<style>

</style>
